import { TopbarComponent } from "./topbarComponent";

export const PatientTopbar = TopbarComponent;
